<template>
  <div
    v-if="isLoading"
    :class="{
      'view-loading-spinner': true,
      'view-loading-spinner--absolute': positioning === 'absolute',
      'view-loading-spinner--flex-center': positioning === 'flex-center',
    }"
  >
    <spinner-wrapper :size="SpinnerSize.L" />
  </div>
  <slot v-else></slot>
</template>

<script lang="ts" setup>
  import { SpinnerSize } from '../SpinnerWrapper/SpinnerWrapper.types';

  withDefaults(
    defineProps<{
      isLoading: boolean;
      positioning?: 'absolute' | 'flex-center';
    }>(),
    {
      positioning: 'absolute',
    },
  );
</script>

<style lang="scss" scoped>
  .view-loading-spinner {
    &--absolute {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &--flex-center {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
